import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { loggedOut } from '../actions';

class LoggedUserButtons extends React.Component {
    constructor() {
      super();
      this.logOut = this.logOut.bind(this);
    }

    render() {
        return (
            <div className="navbar-nav">
                <div className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Moje konto
                    </a>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                        <Link href="#" className="dropdown-item" to="/password-change">Zmień hasło</Link>
                        <div className="dropdown-divider"></div>
                        <a href="#" className="dropdown-item" onClick={this.logOut}>Wyloguj się</a>
                    </div>
                </div>
            </div>
        );
    }

    logOut() {
        const { dispatch } = this.props;
        fetch(
          `/api/logout`,
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            credentials: 'same-origin'
          }).then(response => {
            if (response.status === 200) {
              dispatch(loggedOut());
              location.href = '#';
            }
          });
      }
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(LoggedUserButtons);



// WEBPACK FOOTER //
// ./components/LoggedUserButtons.js